module.exports = __webpack_public_path__ + "static/media/testi1.5c0377bf.png";